import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";


export default function Inicio({ history }) {

    
    return (
        <>
            <div className="content"></div>
        </>
    );
}